export function abortSignalTimeout(ms) {
    const controller = new AbortController();
    setTimeout(() => controller.abort(new DOMException('TimeoutError')), ms);
    return controller.signal;
}
/*#__PURE__*/
export function isSupported() {
    return ('abort' in AbortSignal &&
        // @ts-expect-error `.timeout`
        typeof AbortSignal.timeout === 'function');
}
/*#__PURE__*/
export function isPolyfilled() {
    // @ts-expect-error `.timeout`
    return AbortSignal.timeout === abortSignalTimeout;
}
export function apply() {
    if (!isSupported()) {
        // @ts-expect-error `.timeout`
        AbortSignal.timeout = abortSignalTimeout;
    }
}
//# sourceMappingURL=abortsignal-timeout.js.map